import { ORDER_REQUEST_MESSAGES, OrderRequestMessages } from "./order-request-messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { ITEMS_TABLE, ItemsTableMessages } from "../orders/order-items-table.messages";
import {
  ITEMS_TAB_VALIDATION,
  ItemsTableValidationMessages,
} from "../orders/order-items-validation.messages";

export type ItemDataTabMessages = ActionButtonMessages &
  OrderRequestMessages &
  ItemsTableMessages &
  ItemsTableValidationMessages & {
    //Title messages
    itemInformationTitle: string;

    //AutoComplete
    loadingText: string;
    noOptionsItems: string;

    //Label messages
    addSKUInputLabel: string;
    orderAmountLabel: string;

    //New product dialog
    newProductButton: string;
    newProductDialogTitle: string;
    productSearchLabel: string;
    discountCouponLabel: string;
    stockBalanceLabel: string;
    totalValueLabel: string;
    saveButton: string;
    validatingCoupon: string;

    //Error messages
    errorDeleteItem: string;
    skuAlreadyAdded: string;
    couponInvalid: string;
    couponNotApplicable: string;
    couponMinQuantity: string;
    outOfStockLabel: string;
    productOutOfStock: string;
    skuOutOfStock: string;
    quantityExceedsStock: string;
    selectVariationRequired: string;
  };

export const ITEM_DATA_TAB_MESSAGES: ItemDataTabMessages = {
  //Title messages
  itemInformationTitle: "Informações de Produtos",

  //Label messages
  addSKUInputLabel: "Encontre um sku",
  orderAmountLabel: "Total de Produtos",

  //AutoComplete
  loadingText: "Carregando",
  noOptionsItems: "Nanhum item encontrado",

  //New product dialog
  newProductButton: "Novo Produto",
  newProductDialogTitle: "Novo Produto",
  productSearchLabel: "Código / Nome do produto",
  discountCouponLabel: "Cupom de desconto",
  stockBalanceLabel: "Saldo em estoque",
  totalValueLabel: "Valor Total",
  saveButton: "Salvar",
  validatingCoupon: "Validando cupom...",

  //Error messages
  errorDeleteItem: "Não é possível deletar o item.",
  skuAlreadyAdded: "SKU já foi adicionado.",
  couponInvalid: "Cupom inválido ou expirado.",
  couponNotApplicable: "Cupom não se aplica a este produto.",
  couponMinQuantity: "Quantidade mínima do cupom: {minQuantity}.",
  outOfStockLabel: "Sem estoque",
  productOutOfStock: "O produto precisa ter estoque para ser incluído no pedido.",
  skuOutOfStock: "A variação selecionada precisa ter estoque para ser incluída no pedido.",
  quantityExceedsStock: "Quantidade maior que o saldo em estoque ({stock}).",
  selectVariationRequired: "Selecione as variações do produto.",

  ...ITEMS_TAB_VALIDATION,
  ...ITEMS_TABLE,
  ...ORDER_REQUEST_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
